import React, { useState, useEffect } from 'react'

const Timer = ({ isStart, isReset }) => {
  const startTimer = () => {
    const timer = setInterval(() => {
      setTime((time) => time + 1)
    }, 1000)
    return timer
  }

  const stopTimer = (timer) => {
    clearInterval(timer)
  }

  const [time, setTime] = useState(0)
  const [timer, setTimer] = useState(null)

  useEffect(() => {
    if (isStart) {
      setTime(0)
      setTimer(startTimer())
    } else {
      stopTimer(timer)
    }
    return () => {
      stopTimer(timer)
    }
  }, [isStart])

  useEffect(() => {
    if (isReset) {
      setTime(0)
    }
  }, [isReset])

  const timerString = (time) => {
    const hours = Math.floor(time / 3600)
    const minutes = Math.floor((time - hours * 3600) / 60)
    const seconds = time - hours * 3600 - minutes * 60
    return `${hours < 10 ? '0' : ''}${hours}:${
      minutes < 10 ? '0' : ''
    }${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
  }

  return (
    <div className="timer">
      <p>{timerString(time)}</p>
    </div>
  )
}

export default Timer
